import { PropsWithChildren } from 'react';
import { useAnalyticsWalletTracking } from '@/hooks/analytics/useAnalyticsWalletTracking';
import { useLogPageViews } from '@/hooks/analytics/useLogPageviews';
import { useInitCBAnalytics } from '@/hooks/analytics/useInitCBAnalytics';

export function AnalyticsProvider({ children }: PropsWithChildren) {
  useInitCBAnalytics();
  useAnalyticsWalletTracking();
  useLogPageViews(); // Also including page view tracking since it's related

  return <> {children} </>;
}
